import { useNavigate, useParams } from 'react-router-dom';

import { LoadingSpinner } from '../../../../components/LoadingSpinner';
import { MaturityGauge } from '../components/MaturityGauge';
import { useDraft } from '../hooks';

/**
 * Step 4 — show the maturity snapshot derived from the draft and let the user
 * either go back to review more fields or advance to the publish form.
 */
export function DiscoveryMaturityStep(): JSX.Element {
  const { draftId } = useParams<{ draftId: string }>();
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useDraft(draftId);

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <LoadingSpinner />
      </div>
    );
  }
  if (isError || data === undefined) {
    const message = error instanceof Error ? error.message : 'Error desconocido.';
    return (
      <div className="card border-rose-200 bg-rose-50 p-4 text-sm text-rose-800">
        <strong className="font-semibold">No se pudo cargar la madurez.</strong>
        <p className="mt-1">{message}</p>
      </div>
    );
  }

  const goPublish = (): void => {
    if (draftId !== undefined) {
      navigate(`/document-types/discover/${encodeURIComponent(draftId)}/publish`);
    }
  };

  return (
    <div className="space-y-5">
      <header>
        <h1 className="text-2xl font-semibold text-slate-900">Madurez del descubrimiento</h1>
        <p className="mt-1 text-sm text-slate-500">
          Score derivado de la cobertura de muestras, la confianza por campo y
          las correcciones aplicadas durante la revisión.
        </p>
      </header>

      <section className="card p-6">
        <MaturityGauge
          maturity={data.maturity}
          showForcePublish
          onPublish={goPublish}
          onForcePublish={goPublish}
        />
      </section>

      <div className="flex justify-between">
        <button
          type="button"
          className="btn-secondary"
          onClick={() => {
            if (draftId !== undefined) {
              navigate(`/document-types/discover/${encodeURIComponent(draftId)}/review`);
            }
          }}
        >
          ← Atrás
        </button>
      </div>
    </div>
  );
}
